import React from 'react';
import { makeStyles } from "@material-ui/core";

const usePlaceholderStyles = makeStyles(theme => ({
    placeholder: {
        color: theme.palette.common.black,
        opacity: .5
    }
}));

export const PlaceholderForSelect = ({ children }: { children: any }) => {
    const classes = usePlaceholderStyles();
    return <div className={classes.placeholder}>{children}</div>;
};